import { useEffect } from "react";

export const chartColors = [
    "#BE1E2D",
    "#23C96E",
    "#FF8B00",
    "#2CA9E1",
    "#E02D69",
    "#00D1B3",
    "#FF0000",
    "#E2DF9A",
    "#EBE54D",
    "#757449",
    "#FF0051",
    "#113F8C",
    "#61AE24",
    "#D70060",
    "#616161",
    "#E54028",
    "#D0D102",
    "#01A4A4",
    "#00A1CB",
    "#32742C",
    "#F18D05",
    "#F19D09",
    "#DE8C68",
    "#A86C74",
    "#7A3E46",
    "#9E8A8A",
    "#87D0D4",
    "#238E94",
    "#45D178",
    "#095E29",
    "#BDC94F",
    "#D64BD2",
    "#EDAFEB",
    "#D1564D",
    "#F25F49",
    "#006400",
    "#008000",
    "#008080",
    "#191970",
    "#1E90FF",
    "#2F4F4F",
    "#800000",
    "#8B4513",
    "#A52A2A",
    "#BA55D3",
    "#C71585",
    "#DC143C",
    "#FF4500",
    "#FF6347",
    "#FF7F50",
    "#348781",
    "#4C787E",
    "#C0C0C0",
    "#2ECC71",
    "#EC7063",
    "#A569BD",
    "#E59866",
    "#1ABC9C",
    "#AED6F1",
    "#D4EFDF",
    "#D0ECE7",
    "#AEB6BF",
    "#F2D7D5",
    "#E8F8F5",
    "#D7DBDD",
    "#7B7D7D",
];

export function setFiltersLocalStorage(filters) {
    return localStorage.setItem("filters", JSON.stringify(filters));
}

export const MAX_BOOLEANS = 200;

const formatEntityType = (params, et, est) => {
    let paramest = [];
    let entityType = et.split(",");
    let entitySubType = est.split(",");

    let boolStrings = [];

    if (entityType.includes("person")) {
        let personBoolean = "post.entity_type:person ";
        let subParams = [];
        if (entitySubType.includes("male")) subParams.push("male");
        if (entitySubType.includes("female")) subParams.push("female");
        if (entitySubType.includes("unknown")) subParams.push("unknown");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            personBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${personBoolean})`);
    }

    if (entityType.includes("non-person")) {
        let nonPerBoolean = "post.entity_type:non-person ";
        let subParams = [];
        if (entitySubType.includes("brand")) subParams.push("brand");
        if (entitySubType.includes("news")) subParams.push("news");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            nonPerBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${nonPerBoolean})`);
    }

    if (entityType.includes("unknown")) {
        boolStrings.push(`(post.entity_type:unknown)`);
    }

    params.append("entity_boolean", boolStrings.join(" OR "));
};

// fuction to get contrasting color. EX- helpful in making chart labels contrasting to the background
export const getContrastYIQ = (hexcolor) => {
    if (!hexcolor) return "#000000";
    hexcolor = hexcolor.substr(1);
    let r = parseInt(hexcolor.substr(0, 2), 16);
    let g = parseInt(hexcolor.substr(2, 2), 16);
    let b = parseInt(hexcolor.substr(4, 2), 16);
    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 147.5 ? "#000000" : "#ffffff";
};

export const isProduction = () => {
    let production = false;
    if (
        document.location.origin.indexOf("20twentystage") > -1 ||
        document.location.origin.indexOf("20twentyradarstage") > -1 ||
        document.location.origin.indexOf("radarrstage") > -1 ||
        document.location.origin.indexOf("appstage") > -1 ||
        document.location.origin.indexOf("appdev") > -1 ||
        document.location.origin.indexOf("appdev1") > -1 ||
        document.location.origin.indexOf("appdev2") > -1 ||
        document.location.hostname === "localhost"
    ) {
        production = false;
    } else {
        production = true;
    }

    return production;
};

export const isStagingEnv = () => {
    let devMode = false;
    if (
        document.location.origin.indexOf("20twentystage") > -1 ||
        document.location.origin.indexOf("20twentyradarstage") > -1 ||
        document.location.origin.indexOf("radarrstage") > -1 ||
        document.location.origin.indexOf("appstage") > -1 ||
        document.location.origin.indexOf("appdev") > -1 ||
        document.location.origin.indexOf("appdev1") > -1 ||
        document.location.origin.indexOf("appdev2") > -1 ||
        document.location.hostname === "localhost"
    ) {
        devMode = true;
    } else {
        devMode = false;
    }

    return devMode;
};
